import React from "react";
import styles from "../../static/css/pages.module.css";
import Title from "../../components/title/title";
import RegisterIncomeForm from "./form";
import 'moment/locale/ru';
import ButtonCancel from "../../components/form/button/button_cancel";
import Button from "../../components/form/button/button";
import Icon from "../../components/icons/icons";
import Moment from "react-moment";
import Dropdown from "../../components/form/dropdown/dropdown";
import Modal from "../../components/modal/modal";
import {connect} from "react-redux";
import {dialogAction} from "../../store/actions/dialogAction";
import * as consts from "../../store/constants/dialog";
import ieSvg from "../../components/icons/ieSvg";
import moment from "moment";
import axios from "axios";

class IncomeList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      registerForm: '',
      data: this.props.items,
      items: this.props.items,
      reasonsCancel: [
        {value: 'REGISTRATION_MISTAKE', label: 'Чек сформирован ошибочно'},
        {value: 'REFUND', label: 'Возврат средств'},
      ],
      selectedReason: ''
    };
  }

  componentDidMount() {
    ieSvg();
    this.initMoreFilter();
    let dateStroke = document.querySelectorAll("[data-date]");
    dateStroke.forEach(function(e) {
      e.classList.remove("hidden");
    });
    this.initDateFilter();
    const splitGateURL = process.env.REACT_APP_GATE.split('/');
    this.versionGate = splitGateURL[splitGateURL.length - 2].substring(1)*1;
  }

  componentDidUpdate() {
    this.initMoreFilter();
    var dateStroke = document.querySelectorAll("[data-date]");
    dateStroke.forEach(function(e) {
      e.classList.remove("hidden");
    })
    this.initDateFilter();
  }

  handleFormShow = () => {
    this.setState({registerForm: 'visible'})
  };
  handleFormHide = () => {
    this.setState({registerForm: ''})
  };

  filterList = (event) => {
    let updatedList = this.state.data;
    updatedList = updatedList.filter(function(item){
      const searchVal = event.target.value;
      let isExpand = false;
      const foundServices = item.services.filter((service, i) => {
        const isFound = service.name.toString().toLowerCase().search(
          searchVal.toString().toLowerCase()) !== -1;
        if (searchVal.toString() !== '') isExpand = !isExpand ? isFound && i : isExpand;
        return isFound;
      });
      item.isExpand = !!isExpand;
      return foundServices.length;
    });
    this.setState({items: updatedList});
    if (updatedList.length === 0) {
      document.getElementById("history-empty").style.display = "block";
    }
    else {
      document.getElementById("history-empty").style.display = "none";
    }
  }
  initDateFilter = () => {
    const date = document.querySelectorAll("time");
    date.forEach(function(e){
      const dataValue = e.innerHTML;
      const dataParent = e.closest("[data-history]").previousSibling;
      if (dataParent) {
        const dataParentVal = dataParent.querySelector("time").innerHTML;
        if (dataValue === dataParentVal) {
          e.parentElement.className += " hidden";
        }
      }
    });
  }
  initMoreFilter = () => {
    const historyList = document.querySelectorAll("[data-history]");
    let myArray = Array.from(historyList);
    let newList = myArray.slice(0, 10);
    let showMore = document.querySelector("[data-collapse]");
    historyList.forEach(function(e) {
      e.classList.remove("item_visible");
    })
    if (showMore) {
      newList.forEach(function(e){
        e.className += " item_visible";
        showMore.style.display = "block";
      })
      if (historyList.length < 11 ) {
        showMore.style.display = "none";
      }
    }
  }

  handleStorno = (e) => {
    let parent = e.target.closest("button");
    let form = e.target.closest("[data-form]");
    let reasonValue;
    let nullSelect = form.querySelector(".select__placeholder");
    if (nullSelect) {
      form.querySelector('.dropdown_select').classList.add('invalid-select');
      return;
    }
    else {
      form.querySelector('.dropdown_select').classList.remove('invalid-select');
      reasonValue = form.querySelector(".dropdown_select [name='reasonCancel']").value;
    }
    let operId = parent.getAttribute('data-attr');
    let reasonParam = this.versionGate >= 2 ? 'reasonCode' : 'reason';
    let formData = {
      id: operId,
      [reasonParam]: reasonValue
    }
    this.setState({selectedReason: reasonValue});
    this.props.fetchData(process.env.REACT_APP_GATE + "income/storno", consts.DIALOG, formData)
  }

  handleClose = () => {
    this.props.fetchData('', consts.DIALOG, null);
  };

  handleReload = () => {
    this.props.fetchData('', consts.DIALOG, null);
    this.props.onReload();
  };

  handleCollapse = (e) => {
    const historyList = document.querySelectorAll("[data-history]");
    const historyVisible = document.querySelectorAll(".item_visible[data-history]").length;
    let myArray = Array.from(historyList);
    let newList = myArray.slice(historyVisible, historyVisible + 10);
    newList.forEach(function(e){
      e.className += " item_visible";
    })
    if ((historyVisible + 10) > historyList.length ) {
      e.currentTarget.style.display = "none";
    }
  }

  handleExpand = (e) => {
    const details = e.target.closest('[data-stroke]').nextSibling;
    details.style.display = (details.style.display === 'block') ? 'none' : 'block';
  }

  handleReset = (e) => {
    const details = e.target.closest('[data-stroke]').nextSibling;
    const reason = details.querySelectorAll("[data-reason]");
    details.style.display = "none";
    reason.forEach(function(el){
      el.style.display = "block";
    });
    if (this.versionGate >= 2) {
      const fullLink = process.env.REACT_APP_GATE + 'income/storno/reasons';
      axios.get(fullLink).then(response => {
        let reasonsCancel = [];
        reasonsCancel = response.data.data.stornoIncomeReasons.map(reason => {
          return {
            value: reason.code,
            label: reason.description
          }
        });
        this.setState({reasonsCancel});
      }).catch(error => {
        console.log(error);
      })
    }
  }

  handleCancel = (e) => {
    const details = e.target.closest('[data-reason]').parentNode;
    const reason = details.querySelectorAll('[data-reason]');
    details.style.display = "none";
    reason.forEach(function(el){
      el.style.display = "none";
    })
  }

  renderDialogStorno(param) {
    switch(param) {
      case 'ERROR':
        if(this.props.dialog.items.data.result.errorCode === 'TAXPAYER_UNBOUND' || this.props.dialog.items.data.result.errorCode === 'TAXPAYER_UNREGISTERED') {
          this.props.fetchData('', consts.DIALOG, null);
          window.location=process.env.PUBLIC_URL + "/page/needRegister";
          return null;
        }
        else {
          return <Modal
            class="dialog-success l-align_center"
            modalIcon="icon_error"
            viewbox="0 0 80 80"
            handleClick={this.handleClose.bind(this)}
            title="Доход не удалось отменить"
            body={<div className={styles.article}>
              {this.props.dialog.items.data.result.errorMessage}<br/>
              Попробуйте повторить позже.
              <div className={styles.article}></div>
            </div>}
            footer="l-align_right"
            link={this.handleClose.bind(this)}
            button="Закрыть"
          />;
        }
      case 'TIMEOUT':
        return  <Modal
            class="dialog-success l-align_center"
            modalIcon="icon_error"
            viewbox="0 0 80 80"
            handleClick={this.handleClose.bind(this)}
            title="Что-то пошло не так"
            body={<div className={styles.article}>
              Доход не удалось отменить.<br/>
              Попробуйте повторить позже.
              <div className={styles.article}></div>
            </div>}
            footer="l-align_right"
            link={this.handleClose.bind(this)}
            button="Закрыть"
          />;
      case 'SUCCESS':
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_success"
          viewbox="0 0 80 80"
          handleClick={this.handleReload.bind(this)}
          title="Доход успешно отменен"
          body={<div className={styles.article}>
            Поступление больше не учитывается как ваш доход.
            <div className={styles.article}></div>
          </div>}
          footer="l-align_right"
          link={this.handleReload.bind(this)}
          button="Закрыть"
        />
      default:
        return null;
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <div>
          <div className="l-grid_pt-8 mobile_l-grid">
            <div className="l-grid__item_1"> </div>
            <div className="l-grid__item_6 mobile_l-grid__item_10 l-position_relative">
              <Title icon="icon_menu-operations" title="Мои доходы"/>
              {this.state.registerForm ?
                <div id="register-income-form" className="l-position_relative">
                  <RegisterIncomeForm onSuccess={this.handleReload.bind(this)} />
                  <div className="button_wrap">
                    <ButtonCancel title="Свернуть" onClick={this.handleFormHide} id="form-hide"/>
                  </div>
                </div>
                :
                <div className="title_button">
                  <Button title="Зарегистрировать доход" onClick={this.handleFormShow}/>
                </div>
              }
              {this.state.data.length > 4 ?
                <div className={styles.search}>
                  <Icon name="icon_search" viewbox="0 0 24 24"/>
                  <label className="hidden">Поиск доходов</label>
                  <input type="text" placeholder="Поиск доходов..." className={styles.search_input}
                         onChange={this.filterList}/>
                </div>
                :
                null
              }
              <div>
                {this.state.items.sort((b, a) => Date.parse(a.transferDate) - Date.parse(b.transferDate)).map((d, i) =>
                  <div key={i} className={styles.history} data-history>
                    <div className={styles.history_header} data-date>
                      <Moment format="DD MMMM YYYY" local>
                        {moment.utc(d.transferDate)}
                      </Moment>
                    </div>
                    <div className={styles.history_item} onClick={this.handleExpand} data-stroke>
                      <div className="l-grid_pt-8">
                        <div className="l-grid__item_1">
                          {
                            d.cancelDate !== null ?
                              <span className={`${styles.history_icon} ${styles.history_icon_r}`}>
                                    <Icon name="icon_history_r" viewbox="0 0 32 32"/>
                                  </span>
                              :
                              <span className={styles.history_icon}>
                                    <Icon name="icon_history" viewbox="0 0 32 32"/>
                                  </span>
                          }
                        </div>
                        <div className="l-grid__item_5 l-grid_align-middle text-ellipsed">
                          <div className={styles.history_service}>
                            <div className="text-ellipsed">
                              {d.services?.[0].name}
                            </div>
                          </div>
                        </div>
                        <div className="l-grid__item_1 l-grid_align-middle ie-relative">
                          {
                            d.cancelDate ?
                              <div className="text_sum storned ie-right">
                                - {d.sum.replace('.', ',')}
                              </div>
                              :
                              <div className="text_sum  ie-right">
                                + {d.sum.replace('.', ',')}
                              </div>
                          }
                        </div>
                        <div className="l-grid__item_1 l-grid_align-middle l-align_center">
                          {
                            d.cancelDate ?
                              <span></span>
                              :
                              <span className={styles.edit} onClick={this.handleReset}>
                                    <Icon name="icon_income-cancel" viewbox="0 0 24 24"/>
                                  </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div className={styles.item_details} data-form style={{display: d.isExpand?'block':'none'}}>
                      <div className={styles.item_reason} data-reason>
                        <div className="l-grid_pt-8 mobile_l-grid">
                          <div className="l-grid__item_1"></div>
                          <div className="l-grid__item_6 mobile_l-grid__item_10">
                            {
                              d.cancelDate ?
                                <span></span>
                                :
                                <Dropdown placeholder="Выберите причину" name="reasonCancel" label="Причина отмены дохода"
                                          items={this.state.reasonsCancel} required/>
                            }
                          </div>
                        </div>
                      </div>
                      <div className={styles.item_row}>
                        <div className="l-grid_pt-8 mobile_l-grid">
                          <div className="l-grid__item_1"></div>
                          <div className="l-grid__item_2 mobile_l-grid__item_3">
                            <div className={styles.text_gray}>
                              Дата расчета
                            </div>
                          </div>
                          <div className="l-grid__item_4 mobile_l-grid__item_7">
                            <Moment element="span" local format="DD.MM.YYYY HH:mm">
                              {moment.utc(d.createDate)}
                            </Moment>
                          </div>
                        </div>
                      </div>
                      {
                        d.cancelDate ?
                          <div>
                            <div className={styles.item_row}>
                              <div className="l-grid_pt-8 mobile_l-grid">
                                <div className="l-grid__item_1"></div>
                                <div className="l-grid__item_2 mobile_l-grid__item_3">
                                  <div className={styles.text_gray}>
                                    Дата отмены
                                  </div>
                                </div>
                                <div className="l-grid__item_4 mobile_l-grid__item_7">
                                  <Moment element="span" format="DD.MM.YYYY HH:mm" local>
                                    {moment.utc(d.cancelDate)}
                                  </Moment>
                                </div>
                              </div>
                            </div>
                          </div>
                          :
                          <span></span>
                      }

                      <div className={styles.item_row}>
                        <div className="l-grid_pt-8 mobile_l-grid">
                          <div className="l-grid__item_1"></div>
                          <div className="l-grid__item_2 mobile_l-grid__item_3">
                            <div className={styles.text_gray}>
                              Сумма операции
                            </div>
                          </div>
                          <div className="l-grid__item_4 mobile_l-grid__item_7">
                            {d.sum.replace('.', ',')}
                          </div>
                        </div>
                      </div>
                      <div className={styles.item_row}>
                        <div className="l-grid_pt-8 mobile_l-grid">
                          <div className="l-grid__item_1"></div>
                          <div className="l-grid__item_2 mobile_l-grid__item_3">
                            <div className={styles.text_gray}>
                              Налоговый период
                            </div>
                          </div>
                          <div className="l-grid__item_4 mobile_l-grid__item_7">
                            {d.taxPeriod}
                          </div>
                        </div>
                      </div>
                      <div className={styles.item_row}>
                        <div className="l-grid_pt-8 mobile_l-grid">
                          <div className="l-grid__item_1" />
                          <div className="l-grid__item_2 mobile_l-grid__item_3">
                            <div className={styles.text_gray}>
                              Сумма налога
                            </div>
                          </div>
                          <div className="l-grid__item_4 mobile_l-grid__item_7">
                            {d.tax}
                          </div>
                        </div>
                      </div>
                      <div className={styles.item_row}>
                        <div className="l-grid_pt-8 mobile_l-grid">
                          <div className="l-grid__item_1"/>
                          <div className="l-grid__item_2 mobile_l-grid__item_3">
                            <div className={styles.income_title}>
                              Услуги
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="l-grid_pt-8 mobile_l-grid">
                        <div className="l-grid__item_1"/>
                        <div className="l-grid__item_6 mobile_l-grid__item_10">
                          {
                            d.services.map((item, i) =>
                              <div key={i} className={styles.item_row}>
                                <div className="l-grid_pt-8 mobile_l-grid">
                                  <div className="l-grid__item_1">
                                    {
                                      d.cancelDate !== null ?
                                        <span className={`${styles.history_icon} ${styles.history_icon_r}`}>
                                          <Icon name="icon_history_r" viewbox="0 0 32 32"/>
                                        </span>
                                        :
                                        <span className={styles.history_icon}>
                                          <Icon name="icon_history" viewbox="0 0 32 32"/>
                                        </span>
                                    }
                                  </div>
                                  <div className="l-grid__item_5">
                                    {item.name}
                                    <div className={styles.text_gray} style={{lineHeight: '30px'}}>
                                      {item.quantity}x{item.amount}
                                    </div>
                                  </div>
                                  <div className="l-grid__item_1 mobile_l-grid__item_7">
                                    <div className="text_sum">
                                      {item.amount * item.quantity} <span className={styles.text_gray}>₽</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        </div>
                      </div>
                      <br/>
                      <div className="l-grid_pt-8 mobile_l-grid">
                        <div className="l-grid__item_1"></div>
                        <div className="l-grid__item_2 mobile_l-grid__item_3">
                          <a href={d.link} className={styles.link_with_icon} target="_blank" rel="noopener noreferrer">
                            <Icon name="icon_cheque" viewbox="0 0 24 24"/>Чек
                          </a>
                        </div>
                      </div>
                      <div className={styles.item_reason_buttons} data-reason>
                        {
                          d.cancelDate ?
                            <span></span>
                            :
                            <div className="l-grid_pt-8 mobile_l-grid">
                              <div className="l-grid__item_7 l-align_right mobile_l-grid__item_11">
                                <Button title="Закрыть" datacancel onClick={this.handleCancel}/>
                                <Button title="Отменить доход" dataAttr={d.id} onClick={this.handleStorno}/>
                              </div>
                            </div>
                        }
                      </div>
                    </div>
                  </div>
                )}
                <div className={styles.show_more} onClick={this.handleCollapse} data-collapse>
                  <Icon name="icon_collapse" viewbox={"0 0 24 24"}/>
                </div>
              </div>
              <div className={styles.emptylist} id="history-empty">Операций не найдено</div>
              {this.props.dialog.items ?
                this.renderDialogStorno(this.props.dialog.items.data.result.status)
                :
                null
              }
              <span id="reload-income" onClick={this.handleReload}></span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({dialog: state.updateDialog})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, types, body) => dispatch(dialogAction(url, types, body))}
}

export default connect(mapStateToProps, mapDispatchToProps)(IncomeList);
